<template>
  <div class="time" v-if="left_10">
    <div v-if="inited > 0" class="item">
      <span>{{ time_left | mm_ss }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'timer',
    props: {
      inited: {
        type: [Number],
        default: 0
      },
      label: {
        type: [String, Number],
        default: ''
      }
    },

    data() {
      return {
        time_left: null,
        timer_id: null
      };
    },

    created() {
      this.start_timer();
    },

    computed: {
      left_10() {
        return this.time_left <= 600;
      }
    },

    methods: {
      start_timer() {
        if (this.inited > 0) {
          this.time_left = this.inited;

          this.timer_id = setInterval(() => {
            if (this.time_left === 0) {
              clearInterval(this.timer_id);
              this.$emit('end_time');
            } else {
              this.time_left--;
            }
          }, 1000);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .time {
    z-index: 13;
    box-sizing: border-box;
    position: absolute;
    left: 50px;
    top: 80px;

    .item {
      background: #233346;
      border-radius: 2px;
      width: 50px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.005em;
        color: #ffffff;
      }

      &:before {
        content: '|';
        color: #cfd4db;
        display: inline-block;
        padding: 0 18px;
      }
      &:first-child:before {
        display: none;
      }
    }
  }
</style>
